export default "__VITE_ASSET__DPf36mVU__"